<template>
  <div>
    <div class="container">
        <div class="fill-height downloadContent">
          <img src="/static/images/bg-download@2x.png">
          <div class="download" @click="download()"></div>
        </div>
    </div>
    
    <!-- 下载提示遮罩 -->
    <div v-if="showDownloadGuide" class="download-guide" @click="hideDownloadGuide">
      <img class="guide-arrow-img" src="@/images/arrow.png" alt="arrow" />
      <div class="guide-content">
        <div class="guide-handwrite">点击右上角菜单<br>在浏览器中打开~~</div>
        <div class="guide-btn" @click.stop="hideDownloadGuide">知道了</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "download",
  data() {
    return {
      url: '',
      showDownloadGuide: false,
    };
  },
  components: {},
  methods: {
    download() {
      var ua = navigator.userAgent.toLowerCase();
      var isWeixin = ua.indexOf("micromessenger") != -1;
      var isQQ = ua.indexOf("qq/") != -1;
      var isWeibo = ua.indexOf("weibo") != -1;
      var isDouyin = ua.indexOf("aweme") != -1;
      var isAndroid = ua.indexOf("android") != -1;
      var isIos = ua.indexOf("iphone") != -1 || ua.indexOf("ipad") != -1;
      
      // openinstall 统计下载点击事件
      if (window.openInstallInstance) {
        try {
          // 使用 wakeupOrInstall 方法触发下载或唤醒App
          window.openInstallInstance.wakeupOrInstall();
        } catch (e) {
          console.error('openinstall 统计失败:', e);
        }
      }
      
      // 如果在App内置浏览器中，直接显示提示遮罩
      if (isWeixin || isQQ || isWeibo || isDouyin) {
        this.showDownloadGuide = true;
        return;
      }
      
      // 在外部浏览器中正常下载
      // if (isAndroid) {
      //   location.href = this.url;
      // }
      // if (isIos) {
      //   location.href = "https://apps.apple.com/cn/app/%E5%85%94u/id6479624182";
      // }
    },
    
    hideDownloadGuide() {
      this.showDownloadGuide = false;
    },
    getCallbackVersion() {
      this.$api.getCallbackVersion().then((res) => {
        const data = JSON.parse(res || '{}');
        if (data && data.data){
          this.url = data.data.url;
        }
      });
    },
  },
  created() {
    this.getCallbackVersion();
  },
  mounted() {
  },
};
</script>

<style scoped>
.downloadContent {
  position: relative;
}
.download {
  position: absolute;
  width: 100%;
  height: 18%;
  bottom: 0;
}

.download-guide {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(34,34,34,0.92);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
}

.guide-arrow-img {
  position: fixed;
  top: 12px;
  right: 24px;
  width: 70px;
  height: 70px;
  z-index: 10001;
  pointer-events: none;
}

.guide-content {
  background: rgba(0,0,0,0.7);
  border-radius: 18px;
  padding: 102px 52px;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-shadow: 0 8px 32px rgba(0,0,0,0.25);
}

.guide-handwrite {
  color: #fff;
  font-size: 20px;
  font-family: 'Comic Sans MS', 'Chalkboard SE', 'Comic Neue', cursive, sans-serif;
  text-align: center;
  margin-bottom: 28px;
  letter-spacing: 1px;
  line-height: 1.7;
  text-shadow: 0 2px 8px rgba(0,0,0,0.25);
}

.guide-btn {
  background: #222;
  color: #fff;
  border: none;
  border-radius: 22px;
  padding: 12px 32px;
  font-size: 16px;
  font-weight: bold;
  box-shadow: 0 2px 8px rgba(0,0,0,0.18);
  cursor: pointer;
  margin-top: 8px;
  transition: background 0.2s;
}

.guide-btn:active {
  background: #444;
}
</style>



// WEBPACK FOOTER //
// src/page/download/index.vue